import React from "react";

const ErrorPopUP = ({ show, handleClose, message }) => {
  const emailLink = `<a href="mailto:info@n2nsolutions.com" class="alert-link">info@n2nsolutions.com</a>`;

  let msg = `Oops! Something went wrong and the order couldn't be completed. Please reach out to our sales support team via email at ${emailLink} for help.`;

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content custom-modal-rounded">
          <div
            className="modal-header text-white"
            // style={{ backgroundColor: "#e57d26" }}
          >
            <h5 className="modal-title">Error</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Close"
            />
          </div>
          <div className="modal-body ">
            <div dangerouslySetInnerHTML={{ __html: msg }} />
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={handleClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPopUP;
